import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ed99589"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sa-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "sa-page-title" }, "Super-Administration", -1))
const _hoisted_3 = { class: "sa-subnav" }
const _hoisted_4 = { class: "sa-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "sa-title" }, "Organisationen"),
  /*#__PURE__*/_createElementVNode("p", { class: "sa-subtitle" }, "Alle Einrichtungen verwalten und neue Organisationen anlegen")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "sa-success"
}
const _hoisted_7 = {
  key: 1,
  class: "sa-switch-error"
}
const _hoisted_8 = {
  key: 2,
  class: "sa-loading"
}
const _hoisted_9 = {
  key: 3,
  class: "sa-error"
}
const _hoisted_10 = {
  key: 4,
  class: "sa-card"
}
const _hoisted_11 = { class: "sa-table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Plattform"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_13 = { class: "sa-org-name" }
const _hoisted_14 = { class: "sa-id" }
const _hoisted_15 = { class: "sa-actions" }
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = ["title", "aria-label", "onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "sa-empty"
}, "Noch keine Organisationen vorhanden.", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "sa-modal" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Organisation löschen", -1))
const _hoisted_25 = { class: "sa-delete-lead" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sa-delete-note" }, " Mitarbeitende, die in keiner weiteren Einrichtung arbeiten, verlieren ihr Benutzerkonto. Wer auch anderswo Mitglied ist, behält Konto und Profil. Der MEDA-Kurskatalog und die Vorlagen bleiben unberührt. Das Löschen lässt sich nicht rückgängig machen. ", -1))
const _hoisted_27 = { class: "sa-form-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sa-delete-confirm" }, "Zum Bestätigen den Namen der Organisation eingeben", -1))
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = {
  key: 0,
  class: "sa-form-error"
}
const _hoisted_31 = { class: "sa-modal-actions" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "sa-modal" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Neue Organisation anlegen", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Es wird eine Organisation samt erstem Admin (OWNER) erstellt. Der Admin erhält eine Einladungs-E-Mail mit Zugangsdaten.", -1))
const _hoisted_37 = { class: "sa-form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name der Organisation *", -1))
const _hoisted_39 = { class: "sa-form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name des Admins *", -1))
const _hoisted_41 = { class: "sa-form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-Mail des Admins *", -1))
const _hoisted_43 = {
  key: 0,
  class: "sa-form-error"
}
const _hoisted_44 = { class: "sa-modal-actions" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/superadmin/organisations",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Organisationen")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/courses",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Kurse")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/instruction-library",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Dokumente")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
      }, "+ Neue Organisation")
    ]),
    (_ctx.successMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.successMsg), 1))
      : _createCommentVNode("", true),
    (_ctx.switchError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.switchError), 1))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Organisationen werden geladen …"))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organisations, (org) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: org.organisationId
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(org.name || '—'), 1)
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(org.organisationId), 1),
                    _createElementVNode("td", null, _toDisplayString(org.platformId || '—'), 1),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("button", {
                        class: "btn btn-secondary btn-open",
                        disabled: _ctx.switchingId !== null,
                        onClick: ($event: any) => (_ctx.openOrg(org))
                      }, _toDisplayString(_ctx.switchingId === org.organisationId ? 'Wird geöffnet …' : 'Öffnen'), 9, _hoisted_16),
                      _createElementVNode("button", {
                        class: "sa-icon-danger",
                        type: "button",
                        title: 'Organisation „' + (org.name || org.organisationId) + '“ löschen',
                        "aria-label": 'Organisation ' + (org.name || org.organisationId) + ' löschen',
                        onClick: ($event: any) => (_ctx.askDelete(org))
                      }, _hoisted_19, 8, _hoisted_17)
                    ])
                  ]))
                }), 128)),
                (_ctx.organisations.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
    (_ctx.deleteTarget)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "sa-modal-backdrop",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDelete && _ctx.closeDelete(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("p", _hoisted_25, [
              _createTextVNode(" Die Organisation "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.deleteTarget.name || _ctx.deleteTarget.organisationId), 1),
              _createTextVNode(" wird vollständig entfernt: Berechtigungen und Gruppen, die eigenen Unterweisungen und Dokumente samt Bestätigungen und Nachweisen, alle Zuweisungen sowie die Lernaktivitäten der Mitarbeitenden. ")
            ]),
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                id: "sa-delete-confirm",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deleteConfirmText) = $event)),
                class: "sa-input",
                type: "text",
                autocomplete: "off",
                placeholder: _ctx.deleteTarget.name || _ctx.deleteTarget.organisationId
              }, null, 8, _hoisted_29), [
                [_vModelText, _ctx.deleteConfirmText]
              ])
            ]),
            (_ctx.deleteError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.deleteError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                disabled: _ctx.deleting,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeDelete && _ctx.closeDelete(...args)))
              }, "Abbrechen", 8, _hoisted_32),
              _createElementVNode("button", {
                class: "btn btn-danger-solid",
                disabled: _ctx.deleting || !_ctx.deleteConfirmed,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
              }, _toDisplayString(_ctx.deleting ? 'Wird gelöscht …' : 'Endgültig löschen'), 9, _hoisted_33)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCreate)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "sa-modal-backdrop",
          onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeCreate && _ctx.closeCreate(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.orgName) = $event)),
                type: "text",
                class: "sa-input",
                placeholder: "z. B. Pflegeheim Sonnenhof"
              }, null, 512), [
                [_vModelText, _ctx.form.orgName]
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.adminName) = $event)),
                type: "text",
                class: "sa-input",
                placeholder: "Vor- und Nachname"
              }, null, 512), [
                [_vModelText, _ctx.form.adminName]
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.adminEmail) = $event)),
                type: "email",
                class: "sa-input",
                placeholder: "admin@einrichtung.de"
              }, null, 512), [
                [_vModelText, _ctx.form.adminEmail]
              ])
            ]),
            (_ctx.formError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.formError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                disabled: _ctx.saving,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeCreate && _ctx.closeCreate(...args)))
              }, "Abbrechen", 8, _hoisted_45),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: _ctx.saving,
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submitCreate && _ctx.submitCreate(...args)))
              }, _toDisplayString(_ctx.saving ? 'Wird angelegt …' : 'Anlegen'), 9, _hoisted_46)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}